<script setup lang="ts">
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { useAuthStore } from '../../stores/authStore';

const router = useRouter();
const authStore = useAuthStore();

const currentPath = computed(() => router.currentRoute.value.path);

const navItems = computed(() => {
  const items = [
    { icon: 'grid_view', label: 'Home', path: '/' },
    { icon: 'tune', label: 'Effects', path: '/', isCenter: true },
    { icon: 'favorite', label: 'Favs', path: '/favorites' },
  ];
  
  // Add admin items
  if (authStore.isAdmin) {
    items.push({ icon: 'upload', label: 'Upload', path: '/admin/upload' });
    items.push({ icon: 'settings', label: 'Manage', path: '/admin/manage' });
  }
  
  return items;
});

const emit = defineEmits<{
  (e: 'openEffects'): void;
}>();

interface NavItem {
  icon: string;
  label: string;
  path: string;
  isCenter?: boolean;
}

function handleNavClick(item: NavItem) {
  if (item.isCenter) {
    emit('openEffects');
  } else {
    router.push(item.path);
  }
}
</script>

<template>
  <div class="h-16 flex items-center justify-center gap-12 lg:gap-24 px-6 md:hidden">
    <button
      v-for="item in navItems"
      :key="item.path + item.label"
      @click="handleNavClick(item)"
      :class="[
        'flex flex-col items-center gap-1 group transition-colors',
        item.isCenter
          ? 'relative -top-6 size-16 bg-primary rounded-full flex items-center justify-center text-white shadow-[0_0_25px_rgba(230,0,119,0.5)] border-4 border-background-dark active:scale-90'
          : currentPath === item.path
            ? 'text-primary'
            : 'text-slate-500 hover:text-slate-300'
      ]"
    >
      <span
        :class="[
          'material-symbols-outlined group-hover:scale-110 transition-transform',
          item.isCenter ? 'text-3xl group-hover:rotate-45' : ''
        ]"
      >
        {{ item.icon }}
      </span>
      <span v-if="!item.isCenter" class="text-[10px] font-bold uppercase tracking-tighter">
        {{ item.label }}
      </span>
    </button>
  </div>
</template>
